import { render, staticRenderFns } from "./BlkNavbar.vue?vue&type=template&id=12616869&scoped=true&"
import script from "./BlkNavbar.vue?vue&type=script&lang=ts&"
export * from "./BlkNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./BlkNavbar.vue?vue&type=style&index=0&id=12616869&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12616869",
  null
  
)

export default component.exports